import axios from "axios";
import { roleFromPath } from "@/config/nav";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "jvk_token";

export const api = axios.create({ baseURL: API });

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  // Admins can "view as" a workspace; backend ignores this for non-admins.
  config.headers["X-Act-As"] = roleFromPath(window.location.pathname);
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && getToken() && window.location.pathname !== "/login") {
      clearToken();
      window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);
